import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";

export function useCreateUserPlatformServiceAxiosInstance() {
  const { getAccessTokenSilently } = useAuth0();
  const createUserPlatformServiceAxiosInstance = useCallback(() => {
    const instance = axios.create({
      baseURL: import.meta.env.VITE_USER_PLATFORM_SERVICE_BASE_URL,
    });

    instance.interceptors.request.use(async (req) => {
      req.headers = req.headers.set(
        `Authorization`,
        `Bearer ${await getAccessTokenSilently()}`,
      );
      return req;
    });

    return instance;
  }, [getAccessTokenSilently]);

  return {
    createUserPlatformServiceAxiosInstance,
  };
}
